export const USER_ROW_LIMIT = 10;
export const WIDGETS_API_VERSION = "1";
export const WIDGETS_CLASS_NAMESPACE = "woswidgets";
export const WIDGETS_DATA_ATTRIBUTE_NAMESPACE = "woswidgets";
